import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { ComissaoFaturamentoRoutingModule } from './comissao-faturamento-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ComissaoFaturamentoComponent } from './comissao-faturamento.component';
import { ComissaoListComponent } from './comissao-list/comissao-list.component';
import { ComissaoCardComponent } from './comissao-card/comissao-card.component';
import { ComissaoDialogComponent } from './comissao-dialog/comissao-dialog.component';
import { ComissaoFormComponent } from './comissao-dialog/comissao-form/comissao-form.component';
import { ComissaoVisualizacaoComponent } from './comissao-dialog/comissao-visualizacao/comissao-visualizacao.component';

@NgModule({
  declarations: [
    ComissaoListComponent,
    ComissaoFaturamentoComponent,
    ComissaoCardComponent,
    ComissaoDialogComponent,
    ComissaoFormComponent,
    ComissaoVisualizacaoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    ComissaoFaturamentoRoutingModule
  ],
  exports: [ComissaoFaturamentoComponent]
})
export class ComissaoFaturamentoModule {}
